module.exports = __webpack_public_path__ + "qr2.e01ec4ee.png";